import { Outlet } from 'react-router';

import { ContactButton } from '@/components/contact-button';
import { TooltipProvider } from '@/components/ui/tooltip';

const RootLayout = () => {
  return (
    <TooltipProvider>
      <div className="antialiased bg-white min-h-screen">
        <Outlet />
        <ContactButton />
      </div>
    </TooltipProvider>
  );
};

export default RootLayout;
